import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Description from './components/Description';
import OrganizedBy from './components/OrganizedBy';
import RemoteEventBox from './components/RemoteEventBox';
import './styles.css';
import InPersonEventBox from './components/InPersonEventBox';
import WaitingListBoxes from '@/presentation/components/WaitingListBoxes';
import {
  ContainerBottom,
  ContainerFullScreen,
  EventDetailContainer,
  Title,
  Type
} from './components/styles';
import EventScheduleDays, {
  isSameTime
} from '../../components/eventScheduleDays';
import EventSchedule from '../../components/eventSchedule';
import TextHelper from '../../../../../core/helpers/TextHelper';
import Spinner from '../../../../components/Spinner';
import Processing from '@/presentation/components/Processing';
import Modal from '../../../procedures/components/Modal/Modal';
import ContentModalTwoButtons from '../../../procedures/components/ContentModalTwoButtons';
import iconCancel from '../../../../../assets/illustrations/cancel-procedure.svg';
import iconWarning from '../../../../../assets/illustrations/warning.svg';
import ContentModalOneButton from '../../../procedures/components/ContentModalOneButton';
import EventTags from '../../../../components/EventTags';
import Back from '@/presentation/reusables/Button/Back';
import ReusableDate from '@/presentation/reusables/Date';
import Link from '@/presentation/reusables/Link';
import ReusableInfo from '@/presentation/reusables/Info';
import RenderButton from '../../../../components/RenderButton';
import PopPupRestriction from '@/presentation/reusables/PopRestriction';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';
import { WORKSHOPS_OPTIONS } from '../../constants';
import { getWaitingListStatus } from '@/presentation/modules/reinforcements/components/ReinforcementCard';
import WaitingListModals from '../../../shared/WaitingListModals';

interface EventDetailViewProps {
  event: any;
  isLoading: boolean;
  isProcessing: boolean;
  openWarningModal: boolean;
  openVacanciesModal: boolean;
  goBackButton: () => void;
  onRegister: (idEvent: number) => void;
  onCancelSubscription: (idEvent: number) => void;
  setOpenVacanciesModal: (vacanciesModalState: boolean) => void;
  clearEventSubscribe: () => void;
  openZoomDisabled: boolean;
  setOpenZoomDisabledModal: (show: boolean) => void;
  openZoomNotExistsModal: boolean;
  setOpenZoomNotExistsModal: (show: boolean) => void;
  openMaximumSubscribedModal: boolean;
  setOpenMaximumSubscribedModal: (show: boolean) => void;
  stateEventInscription: () => void;
  onRegisterWaitingList: () => void;
  isRegisteredWaitingList: boolean;
  clearRegisterWaitingList: () => void;
  showWarningWaitingListModal: boolean;
  errorWarningWaitingListMessage: string;
  clearRegisterWaitingListWhenError: () => void;
  onUnregisterWaitingList: () => void;
  restriction: boolean;
  setRestriction: (show: boolean) => void;
}

const EventDetailView = ({
  event,
  isLoading,
  isProcessing,
  goBackButton,
  onRegister,
  onCancelSubscription,
  openWarningModal,
  openVacanciesModal,
  setOpenVacanciesModal,
  clearEventSubscribe,
  openZoomDisabled,
  setOpenZoomDisabledModal,
  openZoomNotExistsModal,
  setOpenZoomNotExistsModal,
  openMaximumSubscribedModal,
  setOpenMaximumSubscribedModal,
  stateEventInscription,
  onRegisterWaitingList,
  isRegisteredWaitingList,
  clearRegisterWaitingList,
  showWarningWaitingListModal,
  errorWarningWaitingListMessage,
  clearRegisterWaitingListWhenError,
  onUnregisterWaitingList,
  restriction,
  setRestriction
}: EventDetailViewProps) => {
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [showVacanciesModal, setShowVacanciesModal] = useState(false);
  const [
    showConfirmUnsuscribeWaitingList,
    setShowConfirmUnsuscribeWaitingList
  ] = useState(false);
  const history = useHistory();

  const {
    address,
    campus,
    classroom,
    description,
    endDate,
    eventSubtype,
    eventType,
    flat,
    isFeatured,
    isOnly,
    isRescheduled,
    isSubscribed,
    linkMeet,
    modality,
    schedule,
    startDate,
    totalWeeks,
    sessionsWeek,
    linkInformationDes,
    linkInformation,
    canUnsubscribe,
    isToday
  } = event || {};
  const isProfessionalTools =
    eventSubtype?.name.toLowerCase() ===
    WORKSHOPS_OPTIONS[3].label.toLowerCase();

  const handleSubscribe = (idEvent: number) => {
    setShowRegisterModal(false);
    onRegister(idEvent);
  };

  useEffect(() => {
    setShowWarningModal(openWarningModal);
  }, [openWarningModal]);

  useEffect(() => {
    setShowVacanciesModal(openVacanciesModal);
  }, [openVacanciesModal]);

  const { name, color } = getWaitingListStatus(event?.statusWaitingList);

  return (
    <>
      <ContainerFullScreen data-testid="cmp-event-detail-view">
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <ContainerBottom>
            <Back onClick={goBackButton} dataTestid="btn-back-event-detail" />
          </ContainerBottom>
        </div>
        {isLoading && <Spinner />}

        {!isLoading && event && (
          <EventDetailContainer>
            <div className="eventDetailContainer">
              <div className="tags">
                <EventTags
                  isToday={isToday}
                  isFeatured={isFeatured}
                  isRescheduled={isRescheduled}
                  name={name}
                  color={color}
                  isSubscribed={isSubscribed}
                />
              </div>
              {eventType.name === 'WORKSHOPS' && (
                <Type>Taller: {eventSubtype?.name}</Type>
              )}
              {eventType.name === 'CONFERENCES' && <Type>Conferencia</Type>}
              {eventType.name === 'ACTIVITIES' && <Type>Actividades</Type>}
              <Title data-testid="cmp-eventDetail-title">{event.name}</Title>
              <ReusableDate
                size={startDate === endDate ? 'large' : 'small'}
                endDate={endDate}
                fontSize="14px"
                gap="8px"
                showPrefix
                startDate={startDate}
                style={{ marginBottom: '6px' }}
                isOnly={isOnly}
                schedule={schedule}
              />
              {isSameTime(schedule) && (
                <div className="fields">
                  <EventScheduleDays
                    isOnly={isOnly}
                    isCard
                    schedule={schedule}
                  />
                </div>
              )}
              {!isOnly && (
                <div className="fields">
                  <EventSchedule
                    isCanceled={false}
                    isOnly={isOnly}
                    schedule={schedule}
                  />
                </div>
              )}
              {!isOnly && (
                <>
                  <div className="fields">
                    Duración: {totalWeeks} semana{totalWeeks > 1 ? 's' : ''}
                  </div>
                  <div className="fields">
                    Sesiones por semana: {sessionsWeek}
                  </div>
                </>
              )}
              <div className="fields">
                <div>
                  {eventType.name === 'WORKSHOPS' ? 'Docente' : 'Ponente'}:{' '}
                  {TextHelper.capitalize(event.teacher)}
                </div>
              </div>
              {event.vacancies > 0 && (
                <div className="fields">Vacantes: {event.vacancies}</div>
              )}
              <Description descriptionDetails={description} />
              {linkInformationDes && (
                <div style={{ marginBottom: '24px', paddingTop: '16px' }}>
                  <Link
                    linkType="external"
                    linkName={linkInformationDes}
                    iconName="external-link"
                    url={linkInformation}
                    iconSpacing={4}
                  />
                </div>
              )}
              {event?.modality === 'P' &&
                event?.eventType?.id === 1 && ( // WORKSHOPS - Presencial
                  <ReusableInfo
                    style={{ marginTop: 8 }}
                    iconName="info"
                    text="Al inscribirse, el estudiante declara y garantiza que se encuentra en un estado de salud óptimo que le permite participar en nuestros talleres presenciales."
                  />
                )}
              <OrganizedBy organizedBy={event?.organizer?.name} />
              {modality === 'P' && (
                <InPersonEventBox
                  classroom={classroom}
                  flat={flat}
                  campus={campus}
                  address={address}
                />
              )}
              {modality === 'R' && (
                <RemoteEventBox
                  urlButtonZoom={linkMeet}
                  isSubscribed={isSubscribed}
                  isProfessionalTools={isProfessionalTools}
                />
              )}
              {!isSubscribed && modality === 'R' && !isProfessionalTools && (
                <p
                  style={{
                    fontWeight: '400',
                    fontSize: '12px',
                    lineHeight: '16px',
                    color: '#4F6168'
                  }}
                >
                  El enlace se habilitará luego de tu inscripción.
                </p>
              )}
              <WaitingListBoxes
                event={event}
                onRegisterWaitingList={onRegisterWaitingList}
                onLeaveWaitingList={() =>
                  setShowConfirmUnsuscribeWaitingList(true)
                }
              />
              <div style={{ marginTop: 20 }}>
                <RenderButton
                  isSubscribed={isSubscribed}
                  isProfessionalTools={isProfessionalTools}
                  canUnsubscribe={canUnsubscribe}
                  onCancel={() => setShowCancelModal(true)}
                  onSubscribe={() => {
                    GoogleAnalytics.writeLog(
                      'portal-services-signUpEventDetail',
                      'services'
                    );
                    setShowRegisterModal(true);
                  }}
                  disableSubscribe={['HL', 'LE', 'IN'].includes(
                    event.statusWaitingList
                  )}
                />
              </div>
            </div>
          </EventDetailContainer>
        )}
      </ContainerFullScreen>
      <Processing isOpen={isProcessing} />
      <Modal
        show={showRegisterModal}
        handleClose={() => setShowRegisterModal(false)}
      >
        <ContentModalTwoButtons
          img={null}
          title="¿Estás seguro de inscribirte?"
          subtitle="Confirma tu inscripción."
          showInfo={false}
          textButton1="Sí, inscribirme"
          onClickButton1={() => handleSubscribe(event.idEvent)}
          textButton2="Cancelar"
          onClickButton2={() => setShowRegisterModal(false)}
          onRow
        />
      </Modal>
      <Modal
        show={showCancelModal}
        handleClose={() => setShowCancelModal(false)}
      >
        <ContentModalTwoButtons
          img={iconCancel}
          title="¿Deseas anular esta Inscripción?"
          subtitle="Al aceptar esta acción, recuerda que tendrás que volver a inscribirte."
          showInfo={false}
          textButton1="Sí, anular"
          onClickButton1={() => {
            setShowCancelModal(false);
            onCancelSubscription(event.idEvent);
          }}
          textButton2="Cancelar"
          onClickButton2={() => setShowCancelModal(false)}
        />
      </Modal>
      <Modal
        show={showWarningModal}
        handleClose={() => {
          setShowWarningModal(false);
          clearEventSubscribe();
        }}
      >
        <ContentModalOneButton
          img={iconWarning}
          title="Ocurrió un problema inesperado"
          subtitle="Por favor, vuelve a intentarlo."
          showInfo={false}
          textButton="Entendido"
          style={{ textAlign: 'center' }}
          onClickButton={() => {
            stateEventInscription();
            clearEventSubscribe();
          }}
        />
      </Modal>
      {/* -2 */}
      <Modal
        show={showVacanciesModal}
        handleClose={() => {
          setShowVacanciesModal(false);
          setOpenVacanciesModal(false);
          clearEventSubscribe();
        }}
      >
        <ContentModalOneButton
          img={iconWarning}
          title="Lo sentimos, se acabaron las vacantes"
          subtitle="Te invitamos a escoger otra opción que sea de tu preferencia"
          showInfo={false}
          textButton="Entendido"
          style={{ textAlign: 'center' }}
          onClickButton={() => {
            setShowVacanciesModal(false);
            setOpenVacanciesModal(false);
            clearEventSubscribe();
            history.push(`/servicios/eventos/Inscritos`);
          }}
        />
      </Modal>
      {/* -3 */}
      <Modal
        show={openZoomDisabled}
        handleClose={() => {
          setOpenZoomDisabledModal(false);
          clearEventSubscribe();
          history.push(`/servicios/eventos/Inscritos`);
        }}
      >
        <ContentModalOneButton
          img={iconWarning}
          title="No tienes una cuenta de zoom activa"
          subtitle={
            <>
              Solicitar la activación escribiéndonos por{' '}
              <span className="span-highlight">SAE</span>
            </>
          }
          showInfo={false}
          textButton="Entendido"
          style={{ textAlign: 'center' }}
          onClickButton={() => {
            setOpenZoomDisabledModal(false);
            clearEventSubscribe();
            history.push(`/servicios/eventos/Inscritos`);
          }}
        />
      </Modal>
      {/* -4 */}
      <Modal
        show={openZoomNotExistsModal}
        handleClose={() => {
          setOpenZoomNotExistsModal(false);
          clearEventSubscribe();
          history.push(`/servicios/eventos/Inscritos`);
        }}
      >
        <ContentModalOneButton
          img={iconWarning}
          title="No tienes una cuenta de zoom registrada"
          subtitle={
            <>
              Revisa tu correo institucional con la invitación de zoom o
              consulta con <span className="span-highlight">SAE</span>
            </>
          }
          showInfo={false}
          textButton="Entendido"
          style={{ textAlign: 'center' }}
          onClickButton={() => {
            setOpenZoomNotExistsModal(false);
            clearEventSubscribe();
            history.push(`/servicios/eventos/Inscritos`);
          }}
        />
      </Modal>
      {/* waiting list registered */}
      <WaitingListModals
        isRegisteredWaitingList={isRegisteredWaitingList}
        clearRegisterWaitingList={clearRegisterWaitingList}
        showWarningWaitingListModal={showWarningWaitingListModal}
        clearRegisterWaitingListWhenError={clearRegisterWaitingListWhenError}
        errorWarningWaitingListMessage={errorWarningWaitingListMessage}
        iconWarning={iconWarning}
      />
      <Modal
        show={
          !isProcessing &&
          !showWarningWaitingListModal &&
          showConfirmUnsuscribeWaitingList
        }
        handleClose={() => setShowConfirmUnsuscribeWaitingList(false)}
      >
        <ContentModalTwoButtons
          img={null}
          title="¿Estás seguro de salir de la lista de espera?"
          subtitle="Si sales, perderás tu lugar<br />y tendrás que volver a unirte si aún<br />está disponible el evento.<br />Confírmanos, por favor."
          showInfo={false}
          textButton1="Sí, salir"
          onClickButton1={onUnregisterWaitingList}
          textButton2="Cancelar"
          onClickButton2={() => setShowConfirmUnsuscribeWaitingList(false)}
          onRow
        />
      </Modal>
      {/* -8 */}
      <Modal
        show={openMaximumSubscribedModal}
        handleClose={() => {
          setOpenMaximumSubscribedModal(false);
          clearEventSubscribe();
        }}
      >
        <ContentModalTwoButtons
          img={iconWarning}
          title="Estás inscrito en 2 talleres deportivos y/o culturales."
          subtitle="Si deseas inscribirte en este evento, tendrás que anular tu inscripción de alguno de ellos."
          showInfo={false}
          textButton1="Ir a inscritos"
          textButton2="Lo haré después"
          onClickButton1={() => {
            setOpenMaximumSubscribedModal(false);
            clearEventSubscribe();
            history.push(`/servicios/eventos/Inscritos`);
          }}
          onClickButton2={() => {
            setOpenMaximumSubscribedModal(false);
          }}
        />
      </Modal>
      <Modal show={restriction} handleClose={() => setRestriction(false)}>
        <PopPupRestriction handleClick={() => setRestriction(false)} />
      </Modal>
    </>
  );
};

export default EventDetailView;
